import classNames from 'classnames';
import { AppStatus } from 'components/SubmitAppButton/SubmitAppButton';
import React, { FC, HTMLAttributes } from 'react';
import { t } from 'utils';
import styles from './StatusBadge.module.scss';

export interface IStatusBadge extends HTMLAttributes<HTMLDivElement> {
  status: string;
}

const StatusBadge: FC<IStatusBadge> = (props) => {
  const { status, className } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.approved]: status === AppStatus.APPROVED,
    [styles.published]: status === AppStatus.PUBLISHED,
    [styles.blocked]: status === AppStatus.BLOCKED,
  });

  return <div className={rootClassName}>{t(`status.${status.toLocaleLowerCase()}`)}</div>;
};

export default StatusBadge;
